import script from "./GlobalAppointmentOffcanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalAppointmentOffcanvas.vue?vue&type=script&setup=true&lang=js"

import "./GlobalAppointmentOffcanvas.vue?vue&type=style&index=0&id=97282cd0&lang=css"

const __exports__ = script;

export default __exports__